module.exports = __webpack_public_path__ + "static/media/TC.bd17caf6.svg";